// Decides whether a signed-in user must accept the terms of service
// again. Pure and import-free so the node harness can test it.

/// True only when the current version is known and differs from the
/// version the user's token carries. An unknown current version, for
/// example when the API is unreachable, never prompts.
export function needsTermsAcceptance(claim: string | null, current: string | null): boolean {
  if (current === null) return false;
  return claim !== current;
}
